
/**
 * Plugin: "preserve_search" (selectize.js)
 * Based on: "preserve_on_blur" of Eric M. Klingensmith
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
 * file except in compliance with the License. You may obtain a copy of the License at:
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
Selectize.define('preserve_search', function (options) {
    const self = this;

    options.text = options.text || function (option) {
        return option[this.settings.labelField];
    };

    this.onOptionSelect = (function () {
        const original = self.onOptionSelect;

        return function (e) {
            // Capture the current input value
            const $input = this.$control_input;
            const inputValue = $input.val();

            original.apply(this, [e]);
            this.setTextboxValue(inputValue);
            this.refreshOptions();
            if (this.currentResults.items.length <= 0) {
                this.setTextboxValue('');
                this.refreshOptions();
            }
        };
    }());
});

/**
 * Override default plugin
 */
Selectize.define('remove_button', function (options) {
    const escape_html = function (str) {
        return (`${str}`)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    };

    options = $.extend({
        label: '&times;',
        title: 'Remove',
        className: 'remove',
        append: true,
    }, options);

    /**
     * Appends an element as a child (with raw HTML).
     *
     * @param {string} html_container
     * @param {string} html_element
     * @return {string}
     */
    const append = function (html_container, html_element) {
        // USE SAME FUNCTION IN SINGLE_CLOSE AND MULTI_CLOSE
        const pos = html_container.search(/(<\/[^>]+>\s*)$/);
        return html_container.substring(0, pos) + html_element + html_container.substring(pos);
    };

    const singleClose = function (thisRef) {
        options.className = 'remove-single';

        const self = thisRef;
        const html = `<a href="javascript:void(0)" class="${options.className}" tabindex="-1" title="${escape_html(options.title)}">${options.label}</a>`;

        thisRef.setup = (function () {
            const original = self.setup;
            return function (...args) {
                // override the item rendering method to add the button to each
                if (options.append) {
                    const render_item = self.settings.render.item;
                    self.settings.render.item = function (...args2) {
                        return append(render_item.apply(thisRef, args2), html);
                    };
                }

                original.apply(thisRef, args);

                // add event listener
                thisRef.$control.on('click', `.${options.className}`, (e) => {
                    e.preventDefault();
                    if (self.isLocked) {
                        return;
                    }

                    self.clear();
                });
            };
        }());
    };

    const multiClose = function (thisRef) {
        const self = thisRef;
        const html = `<a href="javascript:void(0)" class="${options.className}" tabindex="-1" title="${escape_html(options.title)}">${options.label}</a>`;

        thisRef.setup = (function () {
            const original = self.setup;
            return function (...args) {
                // override the item rendering method to add the button to each
                if (options.append) {
                    const render_item = self.settings.render.item;
                    self.settings.render.item = function (...args2) {
                        return append(render_item.apply(thisRef, args2), html);
                    };
                }

                original.apply(thisRef, args);

                // add event listener
                thisRef.$control.on('click', `.${options.className}`, (e) => {
                    e.preventDefault();
                    if (self.isLocked) {
                        return;
                    }

                    const $item = $(e.currentTarget).parent();
                    self.setActiveItem($item);
                    if (self.deleteSelection()) {
                        self.setCaret(self.items.length);
                    }
                });
            };
        }());
    };

    if (this.settings.mode === 'single') {
        singleClose(this);
    } else {
        multiClose(this);
    }
});

/**
 *  focusOpen => if true options will open on focus, if false options will open when user starts typing search string
 */

Bingo.AutocompleteSelect = {};
Bingo.AutocompleteSelect.initMultiItem = function (selector, focusOpen = true) {
    $(selector).selectize({
        plugins: ['remove_button', 'preserve_search'],
        placeholder: null,
        openOnFocus: focusOpen,
        create: false,
        render: {
            item(item) {
                return `<div class="M-autocompleteSelect__item"><div class="M-autocompleteSelect__itemInner">${item.text}</div></div>`;
            },
            option(item) {
                return `<div class="M-autocompleteSelect__option">${item.text}</div>`;
            },
        },
        onInitialize() {
            this.$control_input[0].type = 'text';
            this.$control_input.attr('data-lfv-dont-remove-group-error-label', 'true');
            const wrap = $(selector).closest('.js-autocompleteSelect__wrap');
            const input = wrap.find('input');
            input.addClass('A-textField__formElement');
            input.addClass('js-textField__formElement');
            this.$dropdown.prepend(`<div class="M-autocompleteSelect__suggestions js-autocompleteSelect__suggestions">${wrap.data('suggestions-text')}</div>`);
            input.on('keyup', () => {
                const suggestions = wrap.find('.js-autocompleteSelect__suggestions');
                if (input.val() === '') {
                    suggestions.show();
                } else {
                    suggestions.hide();
                }
            });
            this.$dropdown.closest('.selectize-control').addClass('M-autocompleteSelect');
            this.$dropdown.closest('.selectize-control').find('.items').addClass('M-autocompleteSelect__items');
            this.$dropdown.addClass('M-autocompleteSelect__dropdown');
            this.$dropdown_content.addClass('M-autocompleteSelect__options');
        },
    });
};

Bingo.AutocompleteSelect.initSingleItem = function (selector, focusOpen = true) {
    $(selector).selectize({
        plugins: ['remove_button'],
        placeholder: null,
        openOnFocus: focusOpen,
        create: false,
        render: {
            item(item) {
                return `<div class="M-autocompleteSelect__item"><div class="M-autocompleteSelect__itemInner">${item.text}</div></div>`;
            },
            option(item) {
                return `<div class="M-autocompleteSelect__option">${item.text}</div>`;
            },
        },
        onInitialize() {
            const self = this;
            this.$control_input[0].type = 'text';
            this.$control_input.addClass('no-live-validation');
            this.$control_input.attr('data-lfv-dont-remove-group-error-label', 'true');
            const wrap = $(selector).closest('.js-autocompleteSelect__wrap');
            const input = wrap.find('input');
            input.addClass('A-textField__formElement');
            input.addClass('js-textField__formElement');
            this.$dropdown.closest('.selectize-control').addClass('M-autocompleteSelect');
            this.$dropdown.closest('.selectize-control').find('.items').addClass('M-autocompleteSelect__items');
            this.$dropdown.addClass('M-autocompleteSelect__dropdown');
            this.$dropdown_content.addClass('M-autocompleteSelect__options');

            // Workaround: when input is lock allow to clear value anyway.
            this.$control.off('click', '.remove-single');
            this.$control.on('click', '.remove-single', (e) => {
                e.preventDefault();
                self.clear();
            });

            if (this.isFull()) {
                // If value selected lock and hide input to disallow select another value. You have to clear value first.
                this.lock();
                this.$control_input.hide();
                wrap.find('.js-textField').addClass('-labelUp');
            }

            this.$input.on('focus', function () {
                this.focus();
            });
        },
        onChange() {
            // Trigger validation.
            this.$input[0].dispatchEvent(new Event('change'));
        },
        onItemAdd() {
            const wrap = this.$control_input.closest('.js-autocompleteSelect__wrap');

            // Lock and hide input to disallow select another value when value already selected. You have to clear value first.
            this.lock();
            this.$control_input.hide();
            wrap.find('.js-textField').addClass('-labelUp');
        },
        onClear() {
            const wrap = this.$control_input.closest('.js-autocompleteSelect__wrap');

            // Enable and show input to allow select new value.
            this.$control_input.show();
            this.unlock();
            wrap.find('.js-textField').removeClass('-labelUp');
        },
    });
};
